import {
    FormControl,
    FormErrorMessage,
    FormLabel,
    Input,
} from "@chakra-ui/react";
import { Field, Form, Formik } from "formik";
import accountSchema from "../schema/accountSchema";

const ChangeEmailForm = ({ formRef, onClose }) => {
    return (
        <Formik
            innerRef={formRef}
            initialValues={{
                newEmail: "",
            }}
            validationSchema={accountSchema}
            onSubmit={(values, actions) => {
                setTimeout(() => {
                    alert(JSON.stringify(values, null, 2));
                    actions.setSubmitting(false);
                    onClose()
                }, 1000);
            }}
        >
            {({ isSubmitting }) => (
                <Form>
                    <Field name="newEmail">
                        {({ field, form }) => (
                            <FormControl
                                isInvalid={
                                    form.errors.newEmail && form.touched.newEmail
                                }
                            >
                                <FormLabel>Enter a new email *</FormLabel>
                                <Input {...field} type="email" />
                                <FormErrorMessage>
                                    {form.errors.newEmail}
                                </FormErrorMessage>
                            </FormControl>
                        )}
                    </Field>
                </Form>
            )}
        </Formik>
    );
}

export default ChangeEmailForm;